import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Actions from "../../../../store/actions"
import { useSelector, useDispatch } from "react-redux"
import Alert from "../../../common/alert";
import Swal from 'sweetalert2'
import { detect } from 'detect-browser';
import { CustomLogger } from "../../../../store/actions"
import { history } from "../../../../index"
import { Popover } from '@material-ui/core';
import BuildIcon from '@material-ui/icons/Build';
import GestureIcon from '@material-ui/icons/Gesture';
import IdleTracker from 'idle-tracker';
import swal from "../../../common/alert"

const browser = detect();

const NewControlBar = (props) => {

    const Minutes = 15 * 60 * 1000

    const idleTracker = new IdleTracker({
        timeout: Minutes,
        onIdleCallback: (idle) => idleCallbackFunction(idle)
    });

    const dispatch = useDispatch();

    // const [IsVideoOn, setIsVideoOn] = useState(true)
    const [NumberOfCams, setNumberOfCams] = useState(1)
    const [CurrentCam, setCurrentCam] = useState(1)
    const [IsMicOn, setIsMicOn] = useState(true)
    const [CanStopShare, setCanStopShare] = useState(false)
    const [NumberOfNewMsg, setNumberOfNewMsg] = useState(0)
    const [ShouldShowDot, setShouldShowDot] = useState(false)
    const [IsToolsOpen, setIsToolsOpen] = useState(false)
    const [People, setPeople] = useState({})
    const [useLess, setuseLess] = useState(1)

    const [anchorEl, setAnchorEl] = React.useState(null);

    const isHost = useSelector(({ meeting }) => meeting.IsHost)

    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)
    const ScreenShareOn = useSelector(({ meeting }) => meeting.ScreenShareOn);
    const UserData = useSelector(({ auth }) => auth.UserData);
    const isAuth = useSelector(({ meeting }) => meeting.IsHost);
    const localMuteOrNot = useSelector(({ meeting }) => meeting.localMuteOrNot)
    const SOAP = useSelector(({ meeting }) => meeting.SOAP)
    const Chat = useSelector(({ meeting }) => meeting.Chat)
    const ImagesToMap = useSelector(({ meeting }) => meeting.ScreenShotImages)
    const People2 = useSelector(({ meeting }) => meeting.People)
    const PatientsList = useSelector(({ meeting }) => meeting.PatientsList)
    const IsVideoOn = useSelector(({ meeting }) => meeting.isVideoOn)
    const SelectedVideoForROM = useSelector(({ meeting }) => meeting.SelectedVideoForROM);

    const IsMobTab = window.innerWidth < 1024 ? true : false; // true means tab and mob && false means desktop


    // console.log(localMuteOrNot, "localMuteOrNot")

    useEffect(() => {
        if (IsVideoOn === undefined) {
            dispatch({
                type: "CAMERA_CONTROL",
                payload: true,
            })
        }
        if (IsVideoOn === null) {
            dispatch({
                type: "CAMERA_CONTROL",
                payload: true,
            })
        }
    }, [IsVideoOn])

    useEffect(() => {
        if (People2) setPeople(People2)
        UseLessFunction()

    }, [People2])

    // useEffect(() => {
    //     setUpCam()
    // }, [meetingSession])

    useEffect(() => {
        if (!props.ChatBoxOpen && Chat.length > 0) {
            setNumberOfNewMsg(NumberOfNewMsg + 1)
            setShouldShowDot(true)
        }
    }, [Chat])
    useEffect(() => {
        if (props.ChatBoxOpen) {
            setShouldShowDot(false)
            setNumberOfNewMsg(0)
        }
    }, [props.ChatBoxOpen])


    useEffect(() => {

        props.setAmISharingScreen(CanStopShare)
    }, [CanStopShare])

    useEffect(() => {
        if (!ScreenShareOn) {
            setCanStopShare(false)
        }
        if (ScreenShareOn) {
            props.CloseChatBoxHARD()

        }

    }, [ScreenShareOn])


    useEffect(() => {
        const data = sessionStorage.getItem("DefaultSettings")
        if (data) {
            const obj = JSON.parse(data)
            // localMuteOrNot
            // IsVideoOn
            //             if(!obj.IsAudioOn){
            // setlocalMuteOrNot
            //             }
            if (!obj.IsVideoOn) {
                // setIsVideoOn(false)
                dispatch({
                    type: "CAMERA_CONTROL",
                    payload: false,
                })
            }
        }
    }, [])

    let useless = 0;
    useEffect(() => {
        idleTracker.end();
        if (meetingSession && useless !== 1 && Object.keys(People)?.length == 1 && !props.AmISharingScreen) {
            idleTracker.start();
            useless = 1
        }

        return () => {
            idleTracker.end();
        }
    }, [meetingSession, People, props.AmISharingScreen])

    function UseLessFunction() {
        setuseLess(useLess + 1)

        setTimeout(() => {
            UseLessFunction()
        }, 2000);
    }


    function handleClick(event) {
        // setAnchorEl(event.currentTarget);

            if (props.IsWhiteBoardOpen) {
                handleClose()
                Alert("", "warning", "Please close the whiteboard before accessing tools!")
                return
            }

            // console.log("SelectedVideoForROM",SelectedVideoForROM)
            if (PatientsList.length == 0) {
                Alert("", "warning", "Wait for a patient to join before accessing the side menu")
                handleClose()
                return
            }
            // if (!document.getElementById(SelectedVideoForROM)) {
            //     Alert("", "warning", "Please select a patient before accessing the side menu!")
            //     handleClose()
            //     return
            // }
            props.CloseChatBox("ROM")
            handleClose()
    };

    function handleClose() {
        setAnchorEl(null);
    };

    let theInterval;

    async function idleCallbackFunction(e) {
        // console.log(e)
        clearTimeout(theInterval)
        if (e.idle) {
            setTheInterval()
            let timerInterval;

            timerInterval = setInterval(() => {
                const b = Swal.getHtmlContainer()?.querySelector('b')
                console.log(Swal.getTimerLeft(), "Swal.getTimerLeft()")
                b.textContent = (Swal.getTimerLeft() / 1000).toFixed(0)
            }, 100)
            const res = await Swal.fire({
                title: "There has been no activity for 15 minutes!",
                timerProgressBar: true,
                timer: 60000,
                html: `Your meeting will end in <b></b> seconds, if you dont want to end the meeting press "Don't End". `,
                // showCloseButton: true,
                // showCancelButton: true,
                confirmButtonText: "Don't End",
                // cancelButtonText: "No, Just leave meeting"
                // didOpen: () => {
                //     // Swal.showLoading()
                // const b = Swal.getHtmlContainer().querySelector('b')
                // console.log(Swal.getTimerLeft(),"Swal.getTimerLeft()")
                // timerInterval = setInterval(() => {
                //   b.textContent = Swal.getTimerLeft()
                // }, 100)
                //   },
                //   willClose: () => {
                //     clearInterval(timerInterval)
                //   },
            })


            if (!res.value && res.dismiss !== "cancel") return
            clearTimeout(theInterval)
            clearInterval(timerInterval)
        }
    }

    async function setTheInterval() {

        theInterval = setTimeout(() => {
            // console.log("TimeOutRan")
            Swal.close()
            meetingSession?.audioVideo.removeLocalVideoTile();

            if (isHost) {

                const CALL_END_SIGNAL = "CALL_END_SIGNAL"

                meetingSession?.audioVideo.realtimeSendDataMessage(CALL_END_SIGNAL, JSON.stringify({
                    hasHostLeft: true,
                    hasCallEnded: false,
                }), 100000)

            }
            dispatch(Actions.LeaveMeeting(window.location.pathname.replace("/room/", "").substring(0, 9), false,))
            props.openEndMeetingDialog()

        }, 60000)
        // console.log("Timeoutset")
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <span style={IsMobTab ? { height: props.ControlBarOpen ? "130px" : "0px", zIndex: open ? "1000" : "10000" } : { zIndex: open ? "1000" : "10000" }} className={`NewControlsBar `}>
            <div style={IsMobTab ? { height: props.ControlBarOpen ? "130px" : "0px" } : {}} className="NewControlsBarTools">
                <span
                    title={localMuteOrNot ? "Mute" : "Unmute"}
                    onClick={() => {
                        if (Object.keys(People)?.length < 1) return
                        setIsMicOn(meetingSession?.audioVideo?.realtimeIsLocalAudioMuted())
                        dispatch(Actions.MuteUnmute(meetingSession?.audioVideo?.realtimeIsLocalAudioMuted()))
                    }}

                    style={{ cursor: Object.keys(People)?.length < 1 ? "not-allowed" : "pointer" }}


                    className={`ButtonFabSimple ${localMuteOrNot ? "" : "ButtonFabActive"}`}>
                    <img src={`/images/newIcons/${localMuteOrNot ? "mute.svg" : "unmute.svg"}`} />
                </span>
                <span
                    title={"Video"}

                    onClick={async () => {
                        if (Object.keys(People)?.length < 1) return

                        if (IsVideoOn) {
                            // setIsVideoOn(false)
                            dispatch({
                                type: "CAMERA_CONTROL",
                                payload: false,
                            })
                            meetingSession.audioVideo.stopLocalVideoTile();
                            await meetingSession.audioVideo.stopVideoInput();
                        } else {
                            // setIsVideoOn(true)
                            dispatch({
                                type: "CAMERA_CONTROL",
                                payload: true,
                            })
                            const videoInputDevices = await meetingSession.audioVideo.listVideoInputDevices();
                            const videoInputDeviceInfo = videoInputDevices[0]
                            await meetingSession.audioVideo.startVideoInput(videoInputDeviceInfo.deviceId);
                            meetingSession.audioVideo.startLocalVideoTile();
                        }
                    }}

                    style={{ cursor: Object.keys(People)?.length < 1 ? "not-allowed" : "pointer" }}

                    className={`ButtonFabSimple ${IsVideoOn ? "" : "ButtonFabActive"}`}>
                    <img src={`/images/newIcons/${IsVideoOn ? "video-camera.svg" : "video-camera-off.svg"}`} />
                </span>
                <span
                    title={"Hang Up"}

                    style={{ cursor: Object.keys(People)?.length < 1 ? "not-allowed" : "pointer" }}
                    onClick={async () => {
                        if (Object.keys(People)?.length < 1) return
                        let ShouldQuitAll = false;

                        if (isHost) {

                            // ShouldQuitAll = await Swal("End meeting for everyone", "Are you sure you want to end meeting for everyone?", {
                            //     buttons: ["No, Just leave meeting", "Yes, End for everyone!"],
                            //     closeOnClickOutside: false,
                            //     closeOnEsc: false
                            // })

                            const res = await Swal.fire({
                                title: "Are you sure you want to end meeting for everyone?",
                                text: ImagesToMap.length > 0 ? "The captured screens will be sent to your registered email when the meeting ends. The links are valid for 6 hours, please download all the files before expiration." : "",
                                showCloseButton: true,
                                showCancelButton: true,
                                confirmButtonText: "Yes, End for everyone!",
                                cancelButtonText: "No, Just leave meeting"
                            })

                            if (!res.value && res.dismiss !== "cancel") return

                            ShouldQuitAll = res.value || false
                        }
                        if (isHost) {

                            const CALL_END_SIGNAL = "CALL_END_SIGNAL"

                            meetingSession?.audioVideo.realtimeSendDataMessage(CALL_END_SIGNAL, JSON.stringify({
                                hasHostLeft: true,
                                hasCallEnded: ShouldQuitAll,
                            }), 100000)

                        }
                        if (!isHost) {
                            const query = new URLSearchParams(location.search)

                            const IsRegisteredPatients = !query.get("userType") && query.get("userType") != "Patient"
                            const LeaveOrNot = await Swal.fire({
                                title: "Are you sure you want to leave?",
                                text: !IsRegisteredPatients ? "If there are any captured screens or attachments, they will be sent to you on your registered email. The links are valid for 6 hours, please download all the files before expiration." : "",
                                showCloseButton: true,
                                showCancelButton: true,
                                confirmButtonText: "Yes, Leave meeting!",
                                cancelButtonText: "      Cancel       "
                            })
                            if (!LeaveOrNot.value) return



                        }


                        meetingSession.audioVideo.removeLocalVideoTile();
                        // window.removeEventListener('beforeunload', function (e) {
                        //     // Cancel the event
                        //     // e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
                        //     // Chrome requires returnValue to be set
                        //     // e.returnValue = '';
                        // });
                        dispatch(Actions.LeaveMeeting(window.location.pathname.replace("/room/", "").substring(0, 9), ShouldQuitAll,))

                        // const query2 = new URLSearchParams(location.search)

                        // if (query2.has("videosessionid")){
                        //     if (isHost) {
                        //         history.push("/room")
                        //     }
                        //     history.go()
                        // }
                        props.openEndMeetingDialog()

                    }}
                    className="ButtonFabSimple ButtonFabRed">
                    <img src="/images/newIcons/telephone.svg" />
                </span>
                <span
                    title={"Tools"}
                    onClick={(e) => {
                        // setIsToolsOpen(!IsToolsOpen)
                        if (isAuth) {
                            if (props.ChatBoxOpen && props.ChatSectionType == "ROM") {
                                return props.CloseChatBox("ROM")
                            }
                            if (props.ChatBoxOpen && props.ChatSectionType != "ROM") {
                                return props.CloseChatBox("Chat")
                            }
                            handleClick(e)
                        } else {
                            if (props.IsWhiteBoardOpen) {
                                Alert("", "warning", "Please close the whiteboard before accessing chat!")
                                return
                            }

                            props.CloseChatBox("Chat")
                        }
                    }}
                    className={`ButtonFabSimple ${isAuth && props.ChatBoxOpen && props.ChatSectionType == "ROM" ? "ButtonFabActive" : ""} ${!isAuth && props.ChatBoxOpen ? "ButtonFabActive" : ""}`}>
                    {
                        isAuth ?
                            <img src={`/images/newIcons/${props.ChatBoxOpen && props.ChatSectionType == "ROM" ? "more-close.svg" : "more.svg"}`} />
                            : <img src={`/images/newIcons/${props.ChatBoxOpen ? "more-close.svg" : "more.svg"}`} />
                    }
                </span>
                <span
                    title={"Screen Share"}

                    style={{ cursor: Object.keys(People)?.length < 1 ? "not-allowed" : "pointer" }}
                    onClick={async () => {


                        try {
                            if (Object.keys(People)?.length < 1) return


                            if (browser.name == "safari") {
                                if (parseInt(browser.version) < 13) {
                                    return swal("Warning!", `Your safari version ${browser.version} does not support share screen feature, Please upgrade to version 13+ `, "warning")
                                }
                            }

                            if(props.RomStage != 1){
                                const res = await Swal.fire(
                                    {
                                        cancelButtonText: "Cancel",
                                        text: "You can't change tab while ROM is in progress",
                                        title: "Warning!",
                                        // confirmButtonText: "Confirm",
                                        showCloseButton: true,
                                        // showCancelButton: true,
                                    }
                                )
                                // if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return
                                return

                            }
                            const SCREEN_SHARE = "SCREEN_SHARE"


                            if (!ScreenShareOn) {
                                setTimeout(async () => {

                                    if (props.IsWhiteBoardOpen) return Swal.fire("Please close the whiteboard to share screen!", "", "error")
                                    try {
                                        // console.log("")
                                        CustomLogger("screen share starting...")
                                        const res = await meetingSession.audioVideo.startContentShareFromScreenCapture();
                                        CustomLogger("screen share DONE...")

                                        meetingSession?.audioVideo.realtimeSendDataMessage(SCREEN_SHARE, JSON.stringify({
                                            Start: true,
                                            PersonWhoIsSharingScreen: meetingSession._configuration.credentials.attendeeId,
                                        }), 100000)
                                        dispatch({
                                            type: Actions.PERSON_WHO_IS_SHARING_SCREEN,
                                            payload: meetingSession._configuration.credentials.attendeeId
                                        })
                                        dispatch({
                                            type: Actions.SCREEN_SHARE_ON,
                                            payload: true,
                                        })
                                        setCanStopShare(true)
                                    } catch (error) {
                                        CustomLogger("screen share Error...")
                                        console.log(error.message)

                                        if (error.message === "Permission denied by system") {
                                            // return swal("Can't share screen as you don't have permission! ", `Go to: System Preference —> Choose Security & Privacy —> Choose Screen Recording —> inside “Privacy” tab, please make sure to check your browser to allow screen share! `, "error")
                                            Swal.fire({
                                                imageUrl: "/images/request2.png",
                                                // imageHeight: 300,
                                                imageWidth: 335,
                                                imageAlt: 'A tall image',
                                                showCloseButton: true,
                                                title: "Can't share screen as you don't have permission! ",
                                                text: "Please go to System Preference, then choose Security & Privacy, choose Screen Recording. Inside the “Privacy” tab, please make sure to check your browser to allow the screen share feature. It will close your current browser."
                                            })
                                        } else if (error.message === "Permission denied") {

                                        } else if (error.message === "The request is not allowed by the user agent or the platform in the current context.") {

                                        }
                                        else if (error.message == "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.") {

                                        }
                                        else {

                                            Swal.fire({
                                                showCloseButton: true,
                                                title: "Screen sharing is not supported on your device! ",
                                            })
                                        }

                                        meetingSession?.audioVideo.realtimeSendDataMessage(SCREEN_SHARE, JSON.stringify({
                                            Start: false,
                                            PersonWhoIsSharingScreen: "",
                                        }), 100000)
                                        dispatch({
                                            type: Actions.PERSON_WHO_IS_SHARING_SCREEN,
                                            payload: ""
                                        })
                                    }
                                }, 500);





                            }
                            if (CanStopShare) {
                                CustomLogger("Stopping screen share")
                                await meetingSession.audioVideo.stopContentShare();
                                meetingSession?.audioVideo.realtimeSendDataMessage(SCREEN_SHARE, JSON.stringify({
                                    Start: false,
                                    PersonWhoIsSharingScreen: "",

                                }), 100000)
                                dispatch({
                                    type: Actions.PERSON_WHO_IS_SHARING_SCREEN,
                                    payload: ""
                                })
                                dispatch({
                                    type: Actions.SCREEN_SHARE_ON,
                                    payload: false,
                                })
                                setCanStopShare(false)
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }}
                    className={`ButtonFabSimple ${props.AmISharingScreen ? "ButtonFabActive" : ""}`}>
                    <img src={`/images/newIcons/${props.AmISharingScreen ? "sharing-screen.svg" : "sharing-screen-off.svg"}`} />
                </span>
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <ul style={{ width: "136px", marginBottom: "0", }}>
                    <li
                        onClick={() => {
                            if (props.IsWhiteBoardOpen) {
                                handleClose()
                                Alert("", "warning", "Please close the whiteboard before accessing tools!")
                                return
                            }

                            // console.log("SelectedVideoForROM",SelectedVideoForROM)
                            if (PatientsList.length == 0) {
                                Alert("", "warning", "Wait for a patient to join before accessing the side menu")
                                handleClose()
                                return
                            }
                            // if (!document.getElementById(SelectedVideoForROM)) {
                            //     Alert("", "warning", "Please select a patient before accessing the side menu!")
                            //     handleClose()
                            //     return
                            // }
                            props.CloseChatBox("ROM")
                            handleClose()
                        }}
                        className="d-flex align-items-center p-2 myLi" style={{ height: "50px", width: "100%" }}>
                        <BuildIcon className="mr-2" /> Tools
                    </li>
                    {/* <li
                        onClick={() => {
                            if (props.IsWhiteBoardOpen) {
                                handleClose()
                                Alert("", "warning", "Whiteboard is already opened!")
                                return
                            }

                            // console.log("Object.keys(People)?.length :", Object.keys(People)?.length)
                            if (Object.keys(People)?.length == 1) {
                                Alert("", "warning", "Please wait for participants to join before accessing whiteboard!")
                                handleClose()
                                return
                            }

                            if (props.AmISharingScreen) {
                                Alert("", "warning", "Please stop sharing screen before accessing the whiteboard!")
                                handleClose()
                                return
                            }
                            if (props.ChatBoxOpen && props.ChatSectionType == "ROM") {
                                return props.CloseChatBox("ROM")
                            }
                            if (props.ChatBoxOpen && props.ChatSectionType != "ROM") {
                                return props.CloseChatBox("Chat")
                            }
                            props.initWhiteboard()
                            handleClose()
                        }}
                        className="d-flex align-items-center p-2 myLi" style={{ height: "50px", width: "100%" }}>
                        <GestureIcon className="mr-2" /> Whiteboard
                    </li> */}
                </ul>
            </Popover>
        </span>

    )
}

export default NewControlBar
